import { IMenuItemModel } from '../models/Menu';

import FooterLink from '../components/desktopNav/items/footerLink';
import FooterMenu from '../components/desktopNav/items/footerMenu';
import FooterContentBlock from '../components/desktopNav/items/footerContentBlock';
import { MenuItemTypes } from '../interfaces/IMenuItem';
import { PlaceholderEnum } from '../models/Placeholder';
import DoNotSellMyInfoLink from '../components/desktopNav/items/doNotSellMyInfoLink';
import { IItemModel } from '../models/Item';
import ManageCookiesLink from '../components/desktopNav/items/manageCookiesLink';

export type FooterItemComponent = typeof FooterLink | typeof FooterMenu | typeof FooterContentBlock;

interface IItemTypeFactoryMapper {
  [itemTypeName: string]: FooterItemComponent;
}

export interface IFooterFactory {
  mapNavItem(item: IMenuItemModel): FooterItemComponent;
}

const FooterFactory = (): IFooterFactory => {
  const footerItemMapper: IItemTypeFactoryMapper = {
    [MenuItemTypes.menu]: FooterMenu,
    [MenuItemTypes.item]: FooterLink,
    [MenuItemTypes.contentBlock]: FooterContentBlock,
    [PlaceholderEnum.DoNotSellMyInfo]: DoNotSellMyInfoLink,
    [PlaceholderEnum.ManageCookies]: ManageCookiesLink,
  };

  return {
    mapNavItem(item) {
      const itemAsItemModel = item as IItemModel;
      const itemType = (itemAsItemModel.placeholder && itemAsItemModel.placeholder?.type) || '';
      return footerItemMapper[itemType] || footerItemMapper[item.__typename];
    },
  };
};

export default FooterFactory;
